export function rateStatus(status: 'active' | 'pending' | 'inactive') {
  const statusMap = {
    'active': 'aktif',
    'pending': 'menunggu',
    'inactive': 'nonaktif'
  }

  return statusMap[status]
}